/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {getExpenseDefinitionList} from "@/api/ExpenseDefinition"

export default {
  addExpenseDefinition({ commit }, expenseDefinition) {
    return new Promise((resolve, reject) => {
      commit('ADD_EXPENSE_DEFINITION', expenseDefinition)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsExpenseDefinition({ commit },payload) {
    return new Promise((resolve, reject) => {
      getExpenseDefinitionList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_EXPENSE_DEFINITION', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
        
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateExpenseDefinition({ commit }, expenseDefinition) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_EXPENSE_DEFINITION', expenseDefinition)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeExpenseDefinition({ commit }, expenseDefinitionId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_EXPENSE_DEFINITION', expenseDefinitionId)
          resolve();
    })
  },
};
